import React from "react";
//import ReactDOM from 'react-dom';
import axios from 'axios';
import './Homebanner.css';
//import ReactHtml from 'raw-html-react';
class Homebanner1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            banner : []

        }
    }; 
    componentDidMount(){
        axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/resource/Homepage Section/Home Banner1'), {
            headers : { 
        'content-type': 'application/json'}
        })
        .then(response=>{
            this.setState({banner:response.data.data.section_cards[0]})
        console.log(response.data)
        })
        .catch(response=>{
            console.log(response+' api/resource/Homepage Section/Home Banner1')
            //alert("no")
       })
    }
    render() {
         return <div>

<div className="banner-area mt-20px mb-5 ">
        <div className="container-fluid">
            
        <div className="" >
                             <img src={process.env.REACT_APP_API_URL + this.state.banner.image} className="my-banner-border" rel="preload" width="100%" alt="img"/>
                         </div>
            {/*<ReactHtml html={this.state.menu['section_html']}/>*/}
            
        </div>
    </div>
    </div>
          
        }
    }
    export default  Homebanner1;